import React from 'react';

export const PasswordIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="30" height="18" viewBox="0 0 30 18" fill="none">
        <path
            d="M27.2727 6.2729H15.8864C14.7682 3.09563 11.7409 0.818359 8.18182 0.818359C3.66818 0.818359 0 4.48654 0 9.00018C0 13.5138 3.66818 17.182 8.18182 17.182C11.7409 17.182 14.7682 14.9047 15.8864 11.7275H16.3636L19.0909 14.4547L21.8182 11.7275L24.5455 14.4547L30 8.94563L27.2727 6.2729ZM8.18182 13.0911C5.93182 13.0911 4.09091 11.2502 4.09091 9.00018C4.09091 6.75018 5.93182 4.90927 8.18182 4.90927C10.4318 4.90927 12.2727 6.75018 12.2727 9.00018C12.2727 11.2502 10.4318 13.0911 8.18182 13.0911Z"
            fill="#4DA1A9"
        />
    </svg>
);
